import { GetSaleDto } from '@/dtos'
import { Page, Pageable } from '@/types'
import { AxiosInstance } from 'axios'
import axiosInstance from '.'
import { GetAllMyArqanaHorseRegistrationDto, MinimalTechnicalSaleDto, MinimalTechnicalSaleWithSubscriptionsDto } from './auth/myHorseRegistration'

export interface MandatTracking {
  signTrackingId: number
  createdTime: string
  saleId: number
  entityId: number
  entityLastName: string
  entityFirstName: string
  signed: boolean
}

export interface MinimalTechnicalSaleWithSellerLetterDto extends MinimalTechnicalSaleDto {
  sellerLetterDownloadUrl: string
  state: string
  signMandat: boolean
  hasIban: boolean
  mandatTrackings: MandatTracking[]
}

export interface SaleWithRegistrationsDto {
  sale: MinimalTechnicalSaleWithSellerLetterDto
  registrations: Page<GetAllMyArqanaHorseRegistrationDto>
}

export interface SalesWithSumRegistrationsDto {
  sale: MinimalTechnicalSaleWithSubscriptionsDto
  completed: number
  accepted: number
  waitingResponse: number
  refused: number
}

class SaleApi {
  findById(v: number, token?: string): Promise<GetSaleDto> {
    return this.axios.get(`/sale/${v}`, {
      params: {
        token,
      },
    }).then(response => response.data)
  }

  getAllTechnicalSalesForRegistrations(page: Pageable): Promise<Page<SaleWithRegistrationsDto>> {
    return this.axios.get('/sale?dto=withRegistration', { params: { ...page } }).then(v => v.data)
  }

  getAgenda(): Promise<SalesWithSumRegistrationsDto[]> {
    return this.axios.get('/agenda').then(v => v.data)
  }

  private axios: AxiosInstance

  public constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  public async getAllTechnicalSales(): Promise<GetSaleDto[]> {
    const axiosResponse = await this.axios.get('/sale', {
    })
    return axiosResponse.data
  }

  public async getSignUrl(signTrackingId: number): Promise<string> {
    return (await this.axios.get(`sign-mandat/${signTrackingId}`)).data
  }

  public async getMandatTrackings(saleId: number): Promise<MandatTracking[]> {
    return (await this.axios.get('/sale/can-sign', { params: { saleId } })).data
  }
}

export const saleApi = new SaleApi(axiosInstance)
